import { useGetLatestMembership } from '#api/member';
import { useQueryString } from '#hooks/useQueryString';
import { useScheduleManage } from '#providers/SchedulesManage';
import { useEffect } from 'react';
import { useDashboardCustomerMembershipState } from '../dahsboardCustomerMembershipState';

/**
 * 불러오기일 경우 최신 수강권 정보를 불러온다.
 * @param personId
 * @returns
 */
export const useLoadLatest = (personId: string | undefined) => {
  const [load] = useQueryString(['load']);

  const { data: latestMembership } = useGetLatestMembership(personId || '', {
    enabled: !!load && load === 'true'
  });

  const {
    dashboardCustomerMembershipState,
    setDashboardCustomerMembershipState
  } = useDashboardCustomerMembershipState();

  const { setSelectedLecture } = useScheduleManage();

  const isLoad = latestMembership && !!load && load === 'true';

  useEffect(() => {
    if (!isLoad) return;
    setSelectedLecture({
      lectureId: latestMembership.lectureId,
      lectureName: latestMembership.title
    });

    setDashboardCustomerMembershipState({
      ...dashboardCustomerMembershipState,
      lectureId: latestMembership.lectureId,
      sessionDuration: latestMembership.sessionDuration,
      totalRound: latestMembership.totalRound,
      isRequestPayment: !latestMembership.isPaid,
      startedDate: latestMembership.startedDate,
      expiryDate: latestMembership.expiryDate
    });
  }, [latestMembership]);

  return { latestMembership, isLoad };
};
